import * as React from "react";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { resourceNameLogEntry } from "../../../../../../motw_core/Entity/ILogEntry";
import Nameof from "../../../services/NameOf";
import { FadeInArray } from "../../Shared/Animation/FadeInArray";
import { FloatingTools } from "../../Shared/FloatingTools/FloatingTools";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Render, { RenderDiv } from "../../Shared/Render";
import { StyleClass } from "../../Shared/Styles/CSS";
import { logMonumentalFloatingTools } from "source/app/presentation/MainPanel/LogMonumental/FloatingTools/logMonumentalFloatingTools";
import Data from "./../../../services/Data";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { LogMonumentalSteps } from "source/app/presentation/MainPanel/LogMonumental/Steps/LogMonumentalSteps";
import * as moment from "moment";
import { LogMonumentalRow } from "./LogMonumentalRow";
import { ILogMonumentalState } from "./ILogMonumentalState";

class LogMonumental extends React.Component<{}, ILogMonumentalState> {
    constructor(props: {}) {
        super(props);
        this.state = {
            monumentalData: [],
            displayedRows: [],
            daysAgoToShowFrom: 365,
            randomLogEntryId: 0,
        };
    }

    async componentDidMount() {
        Data.Load.Component({
            component: this,
            load: async () =>
                (await ClientDataProvider.GetRecordsAsync(
                    `${resourceNameLogEntry}?order=id.desc&significance=eq.3`
                )) || [],
            stateTarget: Nameof<ILogMonumentalState>("monumentalData"),
            inLoadAll: true,
        });

        State.ShareClass(ESharedComponent.LogMonumental, this);
    }

    async componentDidUpdate(prevProps: {}, prevState: ILogMonumentalState) {
        const oldestDateToShowMoment = GetOldestDateToShowMoment(
            this.state.daysAgoToShowFrom
        );

        const rowsToDisplay = (this.state.monumentalData || [])
            .filter((row) => row.entry[0] !== `.`)
            .filter((row) =>
                moment(row.lastmodifiedtime)
                    .local()
                    .isAfter(oldestDateToShowMoment)
            );

        this.setState({ displayedRows: rowsToDisplay });
        State.ShareClass(ESharedComponent.LogMonumental, this);
    }

    // Required to prevent unncessary renders
    // when Data.Load.All() is called
    shouldComponentUpdate(nextProps: {}, nextState: ILogMonumentalState) {
        return (
            JSON.stringify(nextProps) !== JSON.stringify(this.props) ||
            JSON.stringify(nextState) !== JSON.stringify(this.state)
        );
    }

    render() {
        if (!this.state.monumentalData?.length) {
            return null;
        }

        const oldestDateToShowFrom = GetOldestDateToShowMoment(
            this.state.daysAgoToShowFrom + increaseVisibleNumberOfDaysBy
        )
            .local()
            .fromNow();

        const showMoreItemsText = `show items from ${oldestDateToShowFrom}`;

        return (
            <div id="pnlLogMonumental" className="collapse in marginBottom1em">
                <RenderDiv
                    id="logMonumentalRows"
                    when={this.state.displayedRows.length}
                    withClasses={StyleClass(`logMonumentalRows`, {
                        margin: `10px 10px`,
                    })}
                >
                    <LogMonumentalSteps
                        {...{ data: this.state.displayedRows }}
                    />
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <div style={{ flex: 1 }}></div>
                        <div style={{ flex: `400px`, maxWidth: `600px` }}>
                            <FadeInArray
                                label="logMonumentalRows"
                                array={this.state.displayedRows}
                                render={(logEntry) => (
                                    <LogMonumentalRow
                                        key={logEntry.entry}
                                        logEntry={logEntry}
                                        randomLogEntryId={
                                            this.state.randomLogEntryId
                                        }
                                        allRows={this.state.displayedRows}
                                    />
                                )}
                                itemDelayMs={100}
                            />
                        </div>
                        <div style={{ flex: 1 }}></div>
                    </div>
                </RenderDiv>
                <Render
                    id="ShowMoreItemsLink"
                    when={
                        (this.state.monumentalData?.length || 0) !==
                        this.state.displayedRows.length
                    }
                    withClasses={StyleClass(`centerText`, {
                        textAlign: `center`,
                    })}
                >
                    <IconWithText
                        iconSuffix={EGlyphicon["arrow-down"]}
                        whenClicked={() =>
                            this.setState({
                                daysAgoToShowFrom:
                                    this.state.daysAgoToShowFrom +
                                    increaseVisibleNumberOfDaysBy,
                            })
                        }
                        displayAsBlock
                    >
                        {showMoreItemsText}
                    </IconWithText>
                </Render>
                {FloatingTools({}, logMonumentalFloatingTools)}
            </div>
        );
    }
}

export default LogMonumental;

function GetOldestDateToShowMoment(daysAgoToShowFrom: number) {
    return moment().local().subtract(daysAgoToShowFrom, "days");
}

const increaseVisibleNumberOfDaysBy = 365;
